import React from 'react'
import { Link } from 'react-router-dom'

const CommonFooter = () => {
    return (
        <div>
            <div className="footer d-sm-flex align-items-center justify-content-between border-top bg-white p-3">
                <p className="mb-0">{window.translate("2024-2025 © Hamilton POS. All Right Reserved")}</p>
                <p>
                   {window.translate("Designed & Developed By")}
                    <Link to="#" className="text-primary">
                        {window.translate("Hamilton")}
                    </Link>
                </p>
            </div>


        </div>
    )
}

export default CommonFooter
